// Import external
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

// Import internal
import { ServiceCatalogTemplate } from '@data/models/service-catalog.model';
import { toParams } from '@shared/utils/query-to-params';
import { ErrorService } from '@app/services/error.service';
import { FilterParams } from '@claranet/node-search-filter';

const SERVICE_CATALOG_API_ROOT = '/core/v1/service-catalog-templates';

@Injectable()
export class ServiceCatalogService {
    private errorList;
    constructor(
        private errorService: ErrorService,
        private http: HttpClient,
    ) {
        this.errorList = this.errorService.serviceCatalogErrors;
    }

    public listServiceCatalogTemplates(filterParams: FilterParams): Observable<ServiceCatalogTemplate[]> {
        const params = toParams(filterParams);
        return this.http.get<{ serviceCatalogs: ServiceCatalogTemplate[] }>(SERVICE_CATALOG_API_ROOT, { params }).pipe(
            map((result) => result.serviceCatalogs),
            catchError(this.errorService.errorHandler<ServiceCatalogTemplate[]>(this.errorList, 'Récupération des catalogues de service', []))
        );
    }

}
